<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                <strong>Statutory Inspection Report -</strong>
                Serial No: {{ statInsp.serialNo }}
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Report Date:</strong>
                  <br />
                  {{ statInsp.reportDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p v-bind:class="{ 'text-warning': statInsp.isExpired }">
                  <strong>Next Report Due:</strong>
                  <br />
                  {{ statInsp.nextReportDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p v-if="statInsp.reminderDate != null">
                  <strong>Reminder Date:</strong>
                  <br />
                  {{ statInsp.reminderDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p v-else>
                  <strong>Reminder Date:</strong>
                  <br />OFF
                </p>
                <p v-bind:class="{ 'text-danger': statInsp.isOverdue }">
                  <strong>Overdue Date:</strong>
                  <br />
                  {{ statInsp.overdueDate | moment("dddd, MMMM Do YYYY") }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Created Date:</strong>
                  <br />
                  {{ statInsp.createdDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p>
                  <strong>Last Activity:</strong>
                  <br />
                  {{ statInsp.lastUpdatedDate | moment("dddd, MMMM Do YYYY") }}
                </p>
                <p>
                  <strong>Last Updated by:</strong>
                  <br />
                  {{ statInsp.lastUpdatedBy }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Contractor:</strong>
                  <br />
                  {{ statInsp.contractorName }}
                </p>
                <p>
                  <strong>Contractor Region:</strong>
                  <br />
                  {{ statInsp.contractorRegionName }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Client:</strong>
                  <br />
                  {{ statInsp.clientName }}
                </p>
                <p>
                  <strong>Site:</strong>
                  <br />
                  {{ statInsp.siteName }}
                </p>
                <p>
                  <strong>Building:</strong>
                  <br />
                  {{ statInsp.buildingName }}
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card v-show="statInsp.isPartial" class="md-accent" md-with-hover>
          <md-ripple>
            <md-card-content>
              <strong>PARTIAL/NON INSPECTION:</strong>
              {{ statInsp.partialNote }}
            </md-card-content>
          </md-ripple>
        </md-card>
        <statInspItemList></statInspItemList>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatInspItemList from "../stat-insp-item/StatInspItemList";

export default {
  name: "stat-insp-view",
  data() {
    return {
      itemTypeSelected: 0,
      statInspItemSelected: null
    };
  },
  components: {
    StatInspItemList
  },
  computed: {
    ...mapGetters({
      statInsp: "stat-insp/statInsp"
    })
  },
  async created() {
    await this.$store.dispatch(
      "stat-insp/getStatInsp",
      this.$route.params.statInspId
    );
  }
};
</script>

<style></style>
